import { Box, Button, Stack } from "@mui/material";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Color,
  EduPostTypes,
  FontStyle,
  JobDisplays,
  Slug,
  SurveyButtonStyle,
} from "../../constants";
import { loadedYtScript } from "../../utils/actionUtils";
import { teamInfo } from "../../utils/avatarUtils";
import {
  DownloadTemplateWrapper,
  jobButtonStyle,
  JobDownloads,
  JobFontSize,
  TaggedRow,
} from "../../utils/jobUtils";
import { BlurSpan } from "../../utils/spanUtils";
import DescriptionOverlay from "./DescriptionOverlay";
import JobResourceVid from "./JobResourceVid";

const styles = {
  container: {
    width: "100%",
    // height: '100%',
    borderRadius: JobDisplays.borderRadius,
    backgroundColor: JobDisplays.backgroundColor,
    boxShadow: JobDisplays.boxShadow,
    padding: JobDisplays.padding,
    ...FontStyle.body,
    minWidth: "",
    maxHeight: "calc(100vh - 200px)",
    // overflow: "hidden",
    // textOverflow: "ellipsis",

    // todo: changeback
    overflowX: "hidden",
    overflowY: "scroll",
    zIndex: 1,
    position: "relative",
  },
  compName: {
    fontSize: JobFontSize.title,
    color: "#000",
    textAlign: "left",
    fontWeight: "bold",
  },
  compNameFullSize: {
    fontSize: { xs: JobFontSize.title, md: "36px" },
  },
  sectionBody: {
    ...FontStyle.body,
    fontSize: JobFontSize.medium,
  },
  blueExpand: {
    ...FontStyle.headingBody,
    fontSize: JobFontSize.medium,
    color: "#0672cb",
    cursor: "pointer",
    // textDecoration: "underline",
    paddingTop: "10px",
    "&:hover": {
      color: "#1033CC",
    },
  },
};

export const ResourceContainer = ({
  children,
  fullHeight,
  showDescriptionOverlay = "",
  setHover = () => {},
}) => {
  return (
    <Box
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={{
        ...styles.container,
        ...(fullHeight && { maxHeight: "fit-content" }),
        // transition: "transform 0.2s",
        // "&:hover": {
        //   transform: "scale(1.01)",
        // },
      }}>
      <DescriptionOverlay visible={showDescriptionOverlay} name="resource" />
      <Stack direction="column" spacing={2}>
        {children}
      </Stack>
    </Box>
  );
};

export const ResourceHeader = ({ title, subtitle, fullSize = false }) => {
  return (
    <Stack direction="column" sx={{ minWidth: 0 }} spacing={1}>
      <Box
        sx={{
          ...styles.compName,
          ...(fullSize && styles.compNameFullSize),
        }}>
        {title}
      </Box>
      {subtitle && <Box sx={styles.sectionBody}>{subtitle}</Box>}
    </Stack>
  );
};

export const ResourceBody = ({ data }) => {
  const [showMore, setShowMore] = React.useState(false);
  return (
    <Box sx={styles.sectionBody}>
      {/* {data.list.map((row, i) => (
        <TaggedRow row={row} key={i} />
      ))} */}
      {/* show part or all of the description */}
      {showMore || data.showIdx === -1
        ? data.list.map((row, i) => <TaggedRow row={row} key={i} />)
        : data.list.slice(0, data.showIdx + 1).map((row, i) => {
            return (
              <TaggedRow
                row={row}
                key={i}
                trimIdx={data.showIdx === i ? data.lastElementShown : -1}
                setShowMore={setShowMore}
              />
            );
          })}
    </Box>
  );
};

export const EduBody = ({ description, lastElement, showIdx }) => {
  const [showMore, setShowMore] = React.useState(false);
  return (
    <Box sx={styles.sectionBody}>
      {/* {data.list.map((row, i) => (
        <TaggedRow row={row} key={i} />
      ))} */}
      {/* show part or all of the description */}
      {showMore || showIdx === -1
        ? description.map((row, i) => <TaggedRow row={row} key={i} />)
        : description.slice(0, showIdx + 1).map((row, i) => {
            return (
              <TaggedRow
                row={row}
                key={i}
                trimIdx={showIdx === i ? lastElement : -1}
                setShowMore={setShowMore}
              />
            );
          })}
    </Box>
  );
};
